<template>
  <div>
    <vue-headful
      :title="'Fattoura - '  +  $t('app.main_title')"
      :description="$t('app.main_description')"
      :lang="lang"
    />
    <v-container fluid class="pa-0 ma-0">
      <v-parallax
        height="600"
        src="https://firebasestorage.googleapis.com/v0/b/fattoura-86f56.appspot.com/o/509-3%5BConverted%5D.png?alt=media&token=4428ea6d-b46d-456a-a969-d29a2c765475"
      >
        <v-layout column align-center justify-center class="white--text">
          <h1
            class="white--text mb-2 display-1 text-center"
            style="font-weight: 900; text-shadow: 3px 2px #000000;    text-transform: uppercase;"
          >{{$t('app.main_title')}}</h1>
          <div
            class="white--text subheading mb-3 text--center"
            style="font-weight: 900; text-shadow: 2px 2px #000000 ;text-transform: uppercase;"
          >{{$t('app.sub_title')}}</div>
          <v-btn
            class="blue lighten-2 mt-5"
            dark
            large
            @click="getStarted"
          >{{$t('app.get_started')}}</v-btn>
        </v-layout>
      </v-parallax>
    </v-container>
    <v-container grid-list-md>
      <v-row>
        <v-col lg="4" sm="12">
          <v-card outlined class="mx-auto text-center">
            <v-card-text>
              <div>
                <v-icon size="80" class color="primary">mdi-lock</v-icon>
                <p>All of your invoices are saved securely to our system so you can rest assured that you'll never lose data</p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card outlined class="mx-auto text-center">
            <v-card-text>
              <div>
                <v-icon size="80" class color="primary">mdi-earth</v-icon>
                <p>
                  Access your invoices From Any Device,
                  whether you are logging in from your phone, or your computer
                </p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card outlined class="mx-auto text-center">
            <v-card-text>
              <div>
                <v-icon size="80" class color="primary">mdi-printer-check</v-icon>
                <p>You can simply print your invoices with just a click</p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-layout row wrap>
        <v-flex xs6 lg6 text-center offset-lg3 offset-xs3>
          <v-icon size="80" color="primary">mdi-email-alert</v-icon>
          <div class="headline text-center">{{$t('app.are_you_amazed')}}</div>
          <br />
          <div class="text-center">{{$t('app.are_you_amazed_sub')}}</div>
        </v-flex>
        <v-flex xs6 lg6 offset-xs3 offset-lg3>
          <v-card class="elevation-0 transparent">
            <v-card-text>
              <v-flex xs12 lg6 offset-lg3>
                <v-text-field filled label="Email" v-model="email" persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 text-center lg6 offset-lg3>
                <v-btn
                  class="blue lighten-2 mb-5"
                  dark
                  large
                  @click="subscribe"
                >{{$t('app.get_in_touch')}}</v-btn>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
        
      </v-layout>
      
    </v-container>

  </div>
</template>
<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      lang: "fr",
      email: "",
      imageLink: {
        main:
          "https://firebasestorage.googleapis.com/v0/b/endorfinevue.appspot.com/o/assets%2Fb13f0434-b228-11e6-8e5d-5252025056ab_web_scale_0.4666667_0.4666667__.jpg?alt=media&token=660df23e-599e-434b-9313-ba69c973eeea",
        sub_main:
          "https://firebasestorage.googleapis.com/v0/b/endorfinevue.appspot.com/o/assets%2FNight-Club-Clubbing-Jobs-Abroad2.jpg?alt=media&token=82bbda7d-5df4-430b-9217-adaf1c8485c5",
        logo:
          "https://firebasestorage.googleapis.com/v0/b/endorfinevue.appspot.com/o/assets%2Fandroid-chrome-512x512.png?alt=media&token=8a0a66f6-4741-4ff6-8f28-eb9ec74374df",
        social_cover:
          "https://firebasestorage.googleapis.com/v0/b/endorfinevue.appspot.com/o/assets%2Fo-NIGHTCLUB-facebook.jpg?alt=media&token=cefc5c4c-9714-41da-9c22-f63caf5e89a4"
      }
    };
  },
  mounted() {
    let host = window.location.hostname.split(".");
    if (host.length === 3 && host[0] === "fr") {
      this.lang = "fr";
    }
  },
  methods: {
    getStarted() {
      this.$router.push("app");
    },
    subscribe() {}
  }
};
</script>

<style scoped>
.finedTitle {
  font-weight: 900;
  text-shadow: 2px 2px #000000;
}

.social-icon {
  font-size: 21px;
  color: white;
}
</style>